module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00445.87bd4a71.jpg";